import React, { useState, useEffect } from "react";
import styled, { createGlobalStyle } from "styled-components";
import { rem } from "polished";
import Modal from "react-modal";

import Variations from "./Variations";
import Sizes from "./Sizes";
import Slider from "./Slider";
import Video from "./Video";

const GlobalStyle = createGlobalStyle`
  .ReactModal__Overlay {
    opacity: 0;
    transition: opacity 0.3s;
  }

  .ReactModal__Overlay--after-open {
    opacity: 1;

    .ReactModal__Content {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .ReactModal__Overlay--before-close {
    opacity: 0;

    .ReactModal__Content {
      opacity: 0;
      transform: translateY(${rem(20)});
      transition: opacity 0.3s 0s, transform 0.3s 0s;
    }
  }

  .ReactModal__Content {
    opacity: 0;
    transform: translateY(${rem(20)});
    transition: opacity 0.3s 0.2s, transform 0.3s 0.2s;
  }
`;

const DetailsButton = styled.button`
	appearance: none;
	border: 0;
	font-size: ${rem(15)};
	line-height: 1.3;
	color: #2d71b6;
	background: none;
	padding: 0;
	cursor: pointer;

	&:focus {
		outline: none;
	}
`;

const DetailsModal = ({
	type,
	items,
	open,
	modalToggle,
	videoUrl,
	openSlide,
}) => {
	const [modalIsOpen, setIsOpen] = useState(false);

	function openModal() {
		setIsOpen(true);
		modalToggle();
	}

	function closeModal() {
		setIsOpen(false);
		modalToggle();
	}

	useEffect(() => {
		Modal.setAppElement(document.querySelector("body"));
	}, []);

	const isSlideShow =
		type !== "details" &&
		type !== "sizes" &&
		type !== "video" &&
		items.length > 1;

	const customStyles = {
		content: {
			// top: "50%",
			// left: "50%",
			// transform: "translate(-50%, -50%)",
			padding: 0,
			borderRadius: 0,
			height: isSlideShow ? rem(688) : rem(588),
			width: isSlideShow ? "100%" : rem(940),
			maxWidth: isSlideShow ? "100%" : "90%",
			maxHeight: "90%",
			overflow: "auto",
			border: 0,
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			position: "relative",
			background: "none",
			margin: "auto auto",
		},
		overlay: {
			display: "flex",
			background: "rgba(0,0,0,0.25)",
			backdropFilter: "blur(4px)",
			zIndex: 100,
		},
	};

	const renderSwitch = (param) => {
		switch (param) {
			case "details":
				return <Variations closeModal={closeModal} items={items} />;
			case "sizes":
				return <Sizes closeModal={closeModal} items={items} />;
			case "video":
				return <Video closeModal={closeModal} videoUrl={videoUrl} />;
			default:
				return (
					<Slider
						closeModal={closeModal}
						items={items}
						initialSlide={openSlide}
					/>
				);
		}
	};

	return (
		<React.Fragment>
			<GlobalStyle />

			{/* <DetailsButton onClick={openModal}>See Details</DetailsButton> */}

			<Modal
				closeTimeoutMS={300}
				isOpen={open}
				onRequestClose={modalToggle}
				style={customStyles}
			>
				{renderSwitch(type)}
			</Modal>
		</React.Fragment>
	);
};

export default DetailsModal;
